import type { FC } from 'react';
import { Box } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import type { GridColDef, GridRowSelectionModel } from '@mui/x-data-grid';
import type { HypothesisCreativeEntry } from '../../types/hypothesis';

interface CreativesFlatGridProps {
  rows: HypothesisCreativeEntry[];
  columns: GridColDef[];
  selectedCreatives: string[];
  onSelectionChange: (ids: string[]) => void;
}

const CreativesFlatGrid: FC<CreativesFlatGridProps> = ({
  rows,
  columns,
  selectedCreatives,
  onSelectionChange,
}) => {
  return (
    <Box sx={{ width: '100%' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        checkboxSelection
        rowSelectionModel={selectedCreatives}
        onRowSelectionModelChange={(model: GridRowSelectionModel) => {
          onSelectionChange(model.map(String));
        }}
        keepNonExistentRowsSelected
        hideFooterPagination
        hideFooter
        disableColumnMenu
        rowHeight={60}
        getRowId={(row: HypothesisCreativeEntry) => row.id}
        autoHeight
        sx={{
          '& .MuiDataGrid-cell': {
            display: 'flex',
            alignItems: 'center',
          },
          '& .MuiDataGrid-columnHeaderTitle': {
            fontSize: '0.75rem',
            fontWeight: 600,
            color: 'text.secondary',
          },
        }}
      />
    </Box>
  );
};

export default CreativesFlatGrid;
